import React from 'react';
import styles from '../../business-division.module.scss';

const Infos = ({ infos, selectedLanguage, id }) => {
    return (
        <div className={styles.businessDivisionInfosContainer}>
            {infos?.map((info, i) => (
                <div
                    key={i}
                    className={styles.businessDivisionInfoCard}
                >
                    <h3 className={`${styles.businessDivisionInfoCardTitle} ${styles[id]}`}>
                        {info.title[selectedLanguage]}
                    </h3>

                    <p>
                        {info.content[selectedLanguage]}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default Infos;
